
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Alert } from '../../../common/Alert'
import { Dropdown } from '../../../common/DropDown'
import { UseInput } from '../../../common/UseInput'
import {
	DIMENSION_UNIT_SELECT_ITEMS,
	LANGUAGES,
	MILESTONES,
	WEIGHT_UNIT_SELECT_ITEMS,
	USER_PRIVLILEGES,
	PAGE_PRIMARY_CATEGORY,
	PAGE_SUB_CATEGORY1,
	USER_ACCOUNT_STATUS,
} from '../../../constants'
import { COUNTRY_CODES } from '../../../constants/countryCodes'
import { loadUserProfile } from '../../../redux/actions/userProfileActions'
import { updateUser, getNotificationSubscription, saveNotificationSubscription } from '../../../services/userProfileService'
import LoadingIndicator from '../../LoadingIndicator'
import checkCircle from '../../../assets/images/check-circle-filled.svg'
import CountryCodeDropdown from '../CountryCodeDropdown/index'
import {
	addAllNotifications,
	getCountryCode,
	getLoggedInUserProfile,
	getPhoneNo,
	getUserId,
	getStatus,
	handleMilestone,
	validateMobileCountryCode,
	validateMobileNumber,
	validateName,
	validatePhoneCountryCode,
	validatePhoneNumber,
	getAccountType,
	getPrivileges,
	getRoles,
	validateStationCode
} from '../userManagementUtil'
import { setToLocalStorage } from '../../../utils/StorageUtils'
import sessionKeys from '../../../constants/sessionKeys'
import { sort, getLanguageCode } from '../../../utils/common'
import MESSAGES from '../../../constants/Messages'
import { useTranslation } from 'react-i18next'
import { MULTILANGUAGE_SUPPORT_ENABLED } from '../../../configs/featureControlConfig'
import { addError, pushPageData } from '../../../utils/analytics'
import pageNames from '../../../constants/pageNames'
import Globe from '../../../assets/images/Globe.svg'
import Bell from '../../../assets/images/Bell.svg'
import EtihadCargo from '../../../assets/images/EtihadCargo.jpg'
import { useHistory } from 'react-router-dom';
import { Title } from 'chart.js'
import { Divider } from '../../../common/Divider'
import CommonInput from '../../../common/Resusable/CommonInput'
import { CustomPopup } from '../../../common/Popup/CustomPopup'
import { CommonDropDown } from '../../../common/Resusable/CommonDropDown'
import { BrandedLinkButton } from '../../../common/Buttons'
import { AUTOCOMPLETE_TYPE, FORM_FIELDS } from '../../../constants'
import AirportAutocomplete from '../../AirportAutocomplete'
import {
	getAirportsByCode,
} from "../../../services/searchPanelServices";

const UserProfile = ({ userProfileResponse, getBookingDetails, userProfileError }) => {
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';

	const [isEditable, setIsEditable] = useState(false);
	const [userStatus, setUserStatus] = useState('')
	const [userInitialStatus, setUserInitialStatus] = useState('')
	const [isUserInfoModalOpen, setUserInfoModalOpen] = useState(false);
	const [isPreferencesModalOpen, setPreferencesModalOpen] = useState(false);
	const [isNotificationsModalOpen, setNotificationsModalOpen] = useState(false);
	// const openUserInfoModal = () => setUserInfoModalOpen(true);
	const openUserInfoModal = () => {
		if (userProfile?.defaultAirportCode) {
			setDefaultAirportInput(userProfile.defaultAirportCode)
			setSelectedOrigin(prev => {
				if (!prev || prev.code !== userProfile.defaultAirportCode) {
					return { code: userProfile.defaultAirportCode, name: userProfile.defaultAirportCode }
				}
				return prev
			})
		}
		setUserInfoModalOpen(true)
	}
	
	const closeUserInfoModal = () => setUserInfoModalOpen(false);
	const handleCancelUserInfoModal = () => {
		if (userProfile?.firstName) {
			setFirstName(userProfile.firstName)
		}
		if (userProfile?.lastName) {
			setLastName(userProfile.lastName)
		}
		
		if (userProfile?.defaultAirportCode) {
			setDefaultAirportInput(userProfile.defaultAirportCode)
			getAirportsByCode(userProfile.defaultAirportCode)
				.then(ap => {
					if (ap) setSelectedOrigin(ap)
					else setSelectedOrigin({ code: userProfile.defaultAirportCode, name: userProfile.defaultAirportCode })
				})
				.catch(() => setSelectedOrigin({ code: userProfile.defaultAirportCode, name: userProfile.defaultAirportCode }))
		} else {
			setDefaultAirportInput('')
			setSelectedOrigin(null)
		}
		
		
		
		setError(null)
		setDisableSaveButton(true)
		closeUserInfoModal()
	}

	const openPreferencesModal = () => setPreferencesModalOpen(true);
	const closePreferencesModal = () => setPreferencesModalOpen(false);

	const openNotificationsModal = () => setNotificationsModalOpen(true);
	const closeNotificationsModal = () => setNotificationsModalOpen(false);
	const onChangeStatus = (event) => {
		setUserStatus(event.target.value)
	}

    const [selectedOrigin, setSelectedOrigin] = useState(null)
	const [selectedDestination] = useState(null)


	const handleEdit = () => {
		setIsEditable(true);
		setIsModalOpen(true);

	};
	const handleSubmit = (evt) => {
		evt.preventDefault()
		validateForm()
	}
	const handleModalClose = () => {
		setIsModalOpen(false);
		setIsEditable(false);

	};

	const handleModalConfirm = () => {
		validateForm();
		setIsModalOpen(false);
		setIsEditable(false);

	};

	const [userProfile, setUserProfile] = useState(null)
	
	const [sotedCountryCodes, setSotedCountryCodes] = useState([])
	const {
		value: firstName,
		setValue: setFirstName,
		bind: bindFirstName,
		reset: resetFirstName,
	} = UseInput('')
	const {
		value: lastName,
		setValue: setLastName,
		bind: bindLastName,
		reset: resetLastName,
	} = UseInput('')
	const {
		value: phoneNumber,
		setValue: setPhoneNumber,
		bind: bindPhoneNumber,
		reset: resetPhoneNumber,
	} = UseInput('')
	const {
		value: mobileNumber,
		setValue: setMobileNumber,
		bind: bindMobileNumber,
		reset: resetMobileNumber,
	} = UseInput('')
	const {
        value: defaultAirportInput,
        setValue: setDefaultAirportInput,
        bind: bindDefaultAirportInput,
        reset: resetDefaultAirportInput,
    } = UseInput('', { noSpaceValidation: true, upperCase: true })

	const [weightUnit, setWeightUnit] = useState('')
	const [error, setError] = useState(null)

	const [alertMessage, setAlertMessage] = useState('')
	const [secondAlertMessage, setSecondAlertMessage] = useState('')
	const [createSuccess, setCreateSuccess] = useState(false)
	const [phContryCode, setPhContryCode] = useState('')
	const [mobContryCode, setMobContryCode] = useState('')
	const [milestones, setMilestones] = useState({})
	const [notifications, setNotifications] = useState([])
	const [notificationsSub, setNotificationsSub] = useState([])
	const [disableSaveButton, setDisableSaveButton] = useState(true)
	const [privileges, setPrivileges] = useState({
		bookingPrivilege: false,
		capturePrivilege: false,
		dashBoardPrivilege: false,
		informaticsPrivilege: false,
		allotmentPrivilege: false,
	})
	const [preferences, setPrefences] = useState({
		weightUnit: 'K',
		dimensionUnit: 'C',
		language: 'en_US',
	})

	const [isLoading, setIsLoading] = useState(false)


	const [language, setLanguage] = useState('')
	const [dimensionUnit, setDimensionUnit] = useState('')

	useEffect(() => {
		getBookingDetails(getUserId())
		setSotedCountryCodes(sort(COUNTRY_CODES))

	}, [])

	useEffect(() => {
		if (userProfileResponse) {
			setUserProfileDetails(userProfileResponse.userDetails)
			if (
				userProfileResponse.userDetails &&
				userProfileResponse.userDetails.userId
			) {
				setToLocalStorage(
					sessionKeys.USER_DETAILS,
					JSON.stringify(userProfileResponse.userDetails)
				)
			}
			setIsEditable(false)
			pushPageData(
				pageNames.USER_PROFILE,
				PAGE_PRIMARY_CATEGORY.USER_PROFILE,
				PAGE_SUB_CATEGORY1.USER_MANAGEMENT
			)
		}
		if (userProfileError) {
			addError(
				'ER229',
				i18n.getResource('en', 'errors', MESSAGES.USER_MAPPED_ERROR)
			)
			pushPageData(
				pageNames.USER_PROFILE,
				PAGE_PRIMARY_CATEGORY.USER_PROFILE,
				PAGE_SUB_CATEGORY1.USER_MANAGEMENT
			)
		}
	}, [userProfileResponse, userProfileError])

	useEffect(() => {
		if (userProfileResponse && userProfileResponse.userDetails) {
			const code = userProfileResponse.userDetails.defaultAirportCode || ''
			setDefaultAirportInput(code)
		}
	}, [userProfileResponse, setDefaultAirportInput]) // NEW

    // When userProfile set separately
    useEffect(() => {
        if (userProfile && userProfile.defaultAirportCode) {
            setDefaultAirportInput(userProfile.defaultAirportCode)
        }
    }, [userProfile]) // NEW

	useEffect(() => {
		if (defaultAirportInput && (!selectedOrigin || selectedOrigin.code !== defaultAirportInput)) {
			// initial lightweight object shown as CODE,CODE -> fetch full airport
			getAirportsByCode(defaultAirportInput)
				.then(airport => {
					if (airport && airport.code === defaultAirportInput) {
						setSelectedOrigin(airport)
					} else {
						// fallback minimal object
						setSelectedOrigin({ code: defaultAirportInput, name: defaultAirportInput })
					}
				})
				.catch(() => {
					setSelectedOrigin({ code: defaultAirportInput, name: defaultAirportInput })
				})
		}
	}, [defaultAirportInput])

	useEffect(() => {
		; (async () => {
			setIsLoading(true)
			try {
				if (userProfile) {
					console.log('userProfileuserProfileuserProfile');
					const response = await getNotificationSubscription(userProfile.agentCode, userProfile.userId)
					const notificationMilestones = []
					if (response && response.userId) {
						console.log('response', response);
						if (response.accepted) {
							notificationMilestones.push('Accepted')
						}
						if (response.departed) {
							notificationMilestones.push('Departed')
						}
						if (response.arrived) {
							notificationMilestones.push('Arrived')
						}
						if (response.notified) {
							notificationMilestones.push('Notified')
						}
						if (response.delivered) {
							notificationMilestones.push('Delivered')
						}
					}
					setNotifications(notificationMilestones)
					setNotificationsSub(notificationMilestones)
					console.log('notificationMilestones', notificationMilestones);
					MILESTONES.forEach(function (milestone, index, array) {

						if (notificationMilestones.includes(milestone.label)) {
							setMilestones((prevState) => ({
								...prevState,
								[milestone.id]: true,
							}))
						}

					})
				}

			} catch (error) {
				console.log(error)
			} finally {
				setIsLoading(false)
			}
		})()
	}, [userProfile])

	useEffect(() => {
		if (notifications) {
			if (addAllNotifications(notifications)) {
				setMilestones((prevState) => ({
					...prevState,
					milestone1: true,
				}))
			} else {
				setMilestones((prevState) => ({
					...prevState,
					milestone1: false,
				}))
			}
		}
	}, [notifications])

	const setUserProfileDetails = (type) => {
		const userDetails = userProfileResponse.userDetails
		setUserProfile(userDetails)
		setPhoneNumber(getPhoneNo(userDetails.telephoneNo))
		setPhContryCode(getCountryCode(userDetails.telephoneNo))
		setMobileNumber(getPhoneNo(userDetails.mobileNo))
		setMobContryCode(getCountryCode(userDetails.mobileNo))
		setDefaultAirportInput(userDetails.defaultAirportCode || '')
		setUserStatus(getStatus(userDetails))
		setUserInitialStatus(getStatus(userDetails))

		if (userDetails.preference) {
			setWeightUnit(userDetails.preference.weightUnit)
			setDimensionUnit(userDetails.preference.dimensionUnit)
			setPrefences((prevState) => ({
				...prevState,
				weightUnit: userDetails.preference.weightUnit,
				dimensionUnit: userDetails.preference.dimensionUnit,
				language: MULTILANGUAGE_SUPPORT_ENABLED
					? userDetails.preference.language
					: 'en_US',
			}))
			MULTILANGUAGE_SUPPORT_ENABLED
				? setLanguage(userDetails.preference.language)
				: setLanguage('en_US')
		}
		if (userDetails.roles && userDetails.roles.length) {
			getPrivileges(userDetails.roles, privileges, setPrivileges)
		}

		setFirstName(userDetails.firstName)
		setLastName(userDetails.lastName)

		if (type && type === 'reset' && notificationsSub) {
			MILESTONES.forEach(function (milestone, index, array) {
				if (notificationsSub.includes(milestone.label)) {
					setMilestones((prevState) => ({
						...prevState,
						[milestone.id]: true,
					}))
				} else {
					setMilestones((prevState) => ({
						...prevState,
						[milestone.id]: false,
					}))
				}

			})
		}

		if (
			userDetails.notificationDetails &&
			userDetails.notificationDetails.notificationAction
		) {
			const notificationMilestones =
				userDetails.notificationDetails.notificationAction
			// setNotifications(userDetails.notificationDetails.notificationAction)
			// MILESTONES.forEach(function (milestone, index, array) {
			//     if (type && type === 'reset') {
			//         if (notificationMilestones.includes(milestone.label)) {
			//             setMilestones((prevState) => ({
			//                 ...prevState,
			//                 [milestone.id]: true,
			//             }))
			//         } else {
			//             setMilestones((prevState) => ({
			//                 ...prevState,
			//                 [milestone.id]: false,
			//             }))
			//         }
			//     } else {
			//         if (notificationMilestones.includes(milestone.label)) {
			//             setMilestones((prevState) => ({
			//                 ...prevState,
			//                 [milestone.id]: true,
			//             }))
			//         }
			//     }
			// })
		}
	}

	const getRequest = () => {
		const loggedInUserProfile = getLoggedInUserProfile()
		const roles = getRoles(privileges)
		const requestBody = {
			requestId: Math.floor(Math.random() * 89999 + 10000),
			userDetails: {
				userId: userProfile.userId,
				firstName,
				middleName: userProfile.middleName,
				lastName,
				email: userProfile.email,
				telephoneNo:
					phContryCode !== '' && phoneNumber !== ''
						? `${phContryCode} ${phoneNumber}`
						: null,
				mobileNo:
					mobileNumber
						? `${mobContryCode?.code || '+971'} ${mobileNumber}`
						: null,

				userType: userProfile.userType,
				//roleGroup: userProfile.roleGroup,
				agentCode: loggedInUserProfile.agentCode,
				customerCode: loggedInUserProfile.customerCode,
				companyName: userProfile.companyName,
				companyCode: userProfile.companyCode,
				address: userProfile.address,
				city: userProfile.city,
				state: userProfile.state,
				country: userProfile.country,
				postalCode: userProfile.postalCode,
				stationCode: userProfile.stationCode,
				defaultAirportCode: defaultAirportInput || userProfile.defaultAirportCode,
				statusChanged: userInitialStatus === userStatus ? false : true,
                accountDisabledFlag: userStatus === 'I' ? 'Y' : 'N', 
				preference: preferences,
				roles: roles.length ? roles : null,
				notificationDetails: {
					notificationAction: notifications,
					notificationEmail: [userProfile.email],
					notificationPhoneNo:
						mobileNumber
							? [`${mobContryCode?.code || '+971'} ${mobileNumber}`]
							: null

				},
			},
		}
		return requestBody
	}

	const getNotificationSubscribeRequest = () => {
		const loggedInUserProfile = getLoggedInUserProfile()
		const requestBody = {
			agentCode: loggedInUserProfile.agentCode,
			userId: userProfile.userId,
			userType: userProfile.userId,
			email: userProfile.email,
			station: defaultAirportInput || userProfile.defaultAirportCode,
			status: userProfile.status,
			accepted: notifications && notifications.includes('Accepted'),
			departed: notifications && notifications.includes('Departed'),
			arrived: notifications && notifications.includes('Arrived'),
			notified: notifications && notifications.includes('Notified'),
			delivered: notifications && notifications.includes('Delivered')
		}
		return requestBody
	}

	const validateForm = async () => {
		const fNameValid = await validateName(
			firstName,
			'firstName',
			setError,

			error
		)
		const lNameValid = await validateName(lastName, 'lastName', setError, error)
		// const phNoValid =validatePhoneNumber(
		//     phoneNumber,
		//     phContryCode,
		//     setError,
		//     error
		// )
		const mobNoValid = await validateMobileNumber(
			mobileNumber,
			mobContryCode,
			setError,
			error
		)
		// const phnCountryCodeValid = validatePhoneCountryCode(
		//     phContryCode,
		//     phoneNumber,
		//     setError
		// )
		const mobCountryCodeValid = await validateMobileCountryCode(
			mobContryCode,
			mobileNumber,
			setError
		)
		const airportValid = validateStationCode(defaultAirportInput, setError, 'defaultAirportCode') 

		if (
			fNameValid &&
			lNameValid &&
			// phNoValid &&
			mobNoValid &&
			// phnCountryCodeValid &&
			mobCountryCodeValid &&
			airportValid
		) {
			setIsLoading(true)

			const responseData = await updateUser(getRequest())
				.then((response) => {
					setIsLoading(false)
					if (response.errorDetails && response.errorDetails.length > 0) {
						setAlertMessage(
							`${MESSAGES.USER_PROFILE_SAVE_FAILED} - ${response.errorDetails[0].errorDescription}`,

							addError('ER095', i18n.getResource('en', 'errors', MESSAGES.USER_PROFILE_SAVE_FAILED))

						)
						setCreateSuccess(false)
						window.scrollTo(0, 0)
						getBookingDetails(getUserId())
						return null;
					} else {
						return response
					}
				})
				.catch((error) => {
					setIsLoading(false)
					setAlertMessage(MESSAGES.USER_PROFILE_SAVE_FAILED)
					addError('ER095', i18n.getResource('en', 'errors', MESSAGES.USER_PROFILE_SAVE_FAILED))
					setCreateSuccess(false)
					window.scrollTo(0, 0)
					getBookingDetails(getUserId())
				})
			if (responseData) {
				let saveNotifStatus = true
				try {
					const saveNotifResp = await saveNotificationSubscription(getNotificationSubscribeRequest())
					if (saveNotifResp && saveNotifResp?.status === 'F') {
						saveNotifStatus = false
					}
				} catch (error) {
					saveNotifStatus = false
				}
				setAlertMessage(MESSAGES.USER_PROFILE_SAVE_SUCCESS)
				setCreateSuccess(true)
				if (!saveNotifStatus) {
					setSecondAlertMessage(MESSAGES.USER_PROFILE_SAVE_NOTIFICATION_FAILED)
				}
				window.scrollTo(0, 0)
				getBookingDetails(getUserId())
				setDisableSaveButton(true)
				setIsEditable(false)
				MULTILANGUAGE_SUPPORT_ENABLED &&
					i18n.changeLanguage(
						getLanguageCode(
							preferences?.language ? preferences.language : 'en_US'
						)
					)
				document.title = t('COMMON.EY_CARGO_PORTAL')
			}

		} else {
			console.log('has error', error)
		}
	}
	console.log("error", error);
	const history = useHistory();

	const handleBooking = () => {
		history.push('/booking');
	};

    // Track change to enable save button
    useEffect(() => {
        if (userProfile) {
            if (defaultAirportInput !== (userProfile.defaultAirportCode || '')) {
                setDisableSaveButton(false)
            }
        }
    }, [defaultAirportInput, userProfile])


	const resetNotificationsIfEmpty = () => {
		let notificationMilestones = []

		if (userProfile.notificationDetails) {
			notificationMilestones =
				userProfile.notificationDetails.notificationAction
		}
		if (!notificationMilestones.length) {
			setNotifications([])
			MILESTONES.forEach(function (milestone, index, array) {
				setMilestones((prevState) => ({
					...prevState,
					[milestone.id]: false,
				}))
			})
		}
	}

	const handleCancel = () => {
		setIsEditable(false)
		setDisableSaveButton(true)
		setError(null)
		resetNotificationsIfEmpty()
		setUserProfileDetails('reset')
	}

	const removeError = (event) => {
		const id = event.target.id + ''
		setError((prevState) => ({ ...prevState, [id]: '' }))
	}

	const hasError = (key) => {
		if (error !== null && error[key] && error[key] !== '') {
			return true
		} else {
			return false
		}
	}

	const onChangePhCountryCode = (event) => {
		setPhContryCode(event.value)
	}

	// const onChangeMobCountryCode = (event) => {
	// 	setMobContryCode(event.value)
	// }
	const onChangeMobCountryCode = (selectedItem) => {
		setMobContryCode(selectedItem.code);
	}

	const handleChangeMilestone = (event) => {
		setDisableSaveButton(false)
		handleMilestone(event, notifications, setNotifications, setMilestones)
	}

	const onChangeLanguage = (event) => {
		setDisableSaveButton(false)
		setPrefences({ ...preferences, language: event.target.value })
	}

	const onChangeWeightUnit = (event) => {
		setDisableSaveButton(false)
		setPrefences({ ...preferences, weightUnit: event.target.value })
	}

	const onChangeDimensionUnit = (event) => {
		setDisableSaveButton(false)
		setPrefences({ ...preferences, dimensionUnit: event.target.value })
	}

	const handleAlertClose = () => {
		setAlertMessage('')
		setCreateSuccess(false)
	}

	const handleSecondAlertClose = () => {
		setSecondAlertMessage('')
	}



	const isCancelEnabled = () => {
		const isCancelEnabled = isEditable || !disableSaveButton
		return isCancelEnabled
	}

	const triggerPhoneCodeValidation = () => {
		validatePhoneCountryCode(phContryCode, phoneNumber, setError)
	}

	const triggerMobPhoneCodeValidation = () => {
		validateMobileCountryCode(mobContryCode, mobileNumber, setError)
	}

	const handleDefaultAirportSetError = (fieldKey, errCode) => {
		// Suppress origin error coming from AirportAutocomplete for this field
		if (fieldKey === FORM_FIELDS.ORIGIN) {
			// Only set our airport code error after blur (see wrapper div onBlur)
			return;
		}
	};

	const setDefaultAirportError = () => {
		setError(prev => ({ ...(prev || {}), defaultAirportCode: MESSAGES.INVALID_AIRPORT_CODE }));
	};
	const clearDefaultAirportError = () => {
		setError(prev => ({ ...(prev || {}), defaultAirportCode: '' }));
	};

	// NEW: selection handler
	const onSelectOrigin = (airportObj) => {
		const code = airportObj?.code || ''
		setSelectedOrigin(airportObj)
		setDefaultAirportInput(code)
		setDisableSaveButton(false)
		clearDefaultAirportError('defaultAirportCode')
		if (code) {
			validateStationCode(code, setError, 'defaultAirportCode')
		}
	}

	const defaultAirportDisplay = React.useMemo(() => {
		// Prefer fetched airport object (selectedOrigin) if it has a proper name
		if (
			selectedOrigin &&
			selectedOrigin.code &&
			selectedOrigin.name && 
			selectedOrigin.name !== selectedOrigin.code
		) {
			return `${selectedOrigin.name},${selectedOrigin.code}`
		}
		// Fallback: if only code known now, show code (will be replaced once fetch resolves)
		const code = defaultAirportInput || userProfile?.defaultAirportCode
		return code ? code : '-'
	}, [selectedOrigin, defaultAirportInput, userProfile])

	
	useEffect(() => {
		// Prevent repopulating when user clears the field
		if (!defaultAirportInput) return;

		const code = defaultAirportInput; 
		if (
			code &&
			(
				!selectedOrigin ||
				selectedOrigin.code !== code ||
				(selectedOrigin.name === code)
			)
		) {
			getAirportsByCode(code)
				.then(ap => {
					if (ap && ap.code === code) {
						setSelectedOrigin(ap);
					}
				})
				.catch(() => { /* silent */ });
		}
	}, [defaultAirportInput]);

	const draftCallback = () => { }

	return (
		<div className={`user-profile-panel ${isRTL ? 'rtl' : ''}`}>
			{alertMessage !== '' && (
				<Alert
					isError={!createSuccess}
					showAlert={true}
					message={t(alertMessage, { ns: 'errors' })}
					onAlertClose={handleAlertClose}
					setTimeout={true}
				/>
			)}
			{secondAlertMessage !== '' && (
				<Alert
					isError={true}
					showAlert={true}
					message={t(secondAlertMessage, { ns: 'errors' })}
					onAlertClose={handleSecondAlertClose}
					setTimeout={true}
				/>
			)}
			{isLoading ? <LoadingIndicator /> : <></>}
			{userProfile && (
				<div className='profile-content'>
					{/* <div className='company-info form-item'> */}
						<div className='company-name-inner-wrapper'>
							{userProfile.companyName !== null && (
								<div className='form-info-name'>
									
									{userProfile.companyName}
								</div>
							  )}  
							{userProfile.customerCode !== null && (
								<div className='form-info-right'>
									<div className='form-item-label'>
										{t('COMMON.CUS_CODE')}
									</div>
									<div className='form-item-value'>
										{userProfile.customerCode}
									</div>
								</div>
							)}
						</div>
					{/* </div> */}

					{/* {userProfile.address !== null && (
                                    <p className='form-info'>{userProfile.address}</p>
                                )} */}

					{/* <p className='form-info'>
                                    {userProfile.city ? userProfile.city : ''}
                                </p> */}
					{/* <p className='form-info'>
                                    {userProfile.country ? userProfile.country : ''}
                                    {userProfile.postalCode ? ', ' + userProfile.postalCode : ''}
                                </p> */}

					{isUserInfoModalOpen && (
						<CustomPopup
							isVisible={isUserInfoModalOpen}
							onClose={handleCancelUserInfoModal}
							headerComponent={{
								mainHeader: t('COMMON.USER_INFO'),
								subHeader: t('COMMON.MANAGE_PERSONAL_INFO')
								// subHeader: "Manage your personal information and contact information"
							}}
							showMobileBackButton="true"
							footerPriBtnLabel={t('MNGTMPLT.SAVE_CHANGES')}
							footerPriBtnClick={(evt) => {
								handleSubmit(evt);


								closeUserInfoModal();
							}}


							footerSecBtnClick={handleCancelUserInfoModal}
							fullscreenOnMobile={true}
							footerPriBtnDisabled={
								(error && (error.firstName || error.lastName || error.defaultAirportCode || error.mobileNumber || error.mobContryCode)) ||
								!firstName?.trim() ||
								!lastName?.trim() ||
								!defaultAirportInput?.trim()
							}
						>


							<div className='user-info-content'>
								<div className='form-row'>
									<div
										className=' form-item form-item--text form-item--disabled mb-0'
										data-module='molecules/form-item/FormItem'
									>

										<CommonInput
											type='text'
											label={t('COMMON.USER_ID')}
											className='form-item-value'
											value={userProfile.userId}
											maxLength='25'
											readOnly
										/>
									</div>

									<div
										className=' form-item form-item--text first-name-editable'
										data-module='molecules/form-item/FormItem'
									>
										<CommonInput
											type="text"
											id="firstName"
											label={t('COMMON.FIRST_NAME')}
											value={firstName}
											onChange={bindFirstName.onChange}
											onFocus={removeError}
											onBlur={() => validateName(firstName, 'firstName', setError, error)}
											maxLength={20}
											error={error?.firstName ? t(error.firstName, { ns: 'errors' }) : ''}
											ariaInvalid={hasError('firstName')}
										/>
									</div>
									<div
										className='form-item form-item--text last-name-editable'
										data-module='molecules/form-item/FormItem'
									>
										<CommonInput
											type="text"
											id="lastName"
											label={t('COMMON.LAST_NAME')}
											value={lastName}
											onChange={bindLastName.onChange}
											onFocus={removeError}
											onBlur={() => validateName(lastName, 'lastName', setError, error)}

											maxLength={20}
											error={error?.lastName ? t(error.lastName, { ns: 'errors' }) : ''}
											ariaInvalid={hasError('lastName')}

										/>
									</div>





								</div>
								<div className='form-row'>
									<div
										className='form-item form-item--text form-item--disabled'
										data-module='molecules/form-item/FormItem'
									>

										<CommonInput
											type='text'
											label={t('COMMON.EMAIL')}
											className='form-item-value'
											value={userProfile.email}
											maxLength='100'
											readOnly
										/>
									</div>



									<div
										className='form-item form-item--text'
										data-module='molecules/form-item/FormItem'
									>

										<div className='form-row-mob d-flex '>
											<div
												className={`code
                                             ${error && error['mobContryCode'] ? 'red-border' : ''}`}
											>
												<CountryCodeDropdown
													id="mobContryCode"
													name="mobContryCode"
													autoCompleteType="MOB_COUNTRY_CODE"
													countryCodes={sotedCountryCodes}
													userCountryCode={mobContryCode}
													setCountryCode={onChangeMobCountryCode}
													triggerCodeValidation={triggerMobPhoneCodeValidation}
													setError={setError}
													removeError={removeError}
												/>			<span className='form-item__error'>
													{error && error['mobContryCode']
														? t(error['mobContryCode'], { ns: 'errors' })
														: ''}
												</span>
											</div>

											<div className='mobileNumber'>
												<CommonInput
													type="text"
													id="mobileNumber"
													label={t('COMMON.MOB')}
													value={mobileNumber}
													onChange={bindMobileNumber.onChange}
													maxLength={25}
													disabled={isEditable}
													onFocus={removeError}
													onBlur={() =>
														validateMobileNumber(
															mobileNumber,
															mobContryCode,
															setError,
															error
														)
													}
													error={
														error && error['mobileNumber']
															? t(error['mobileNumber'], { ns: 'errors' })
															: ''
													}
													ariaInvalid={hasError('mobileNumber')}
												// wrapperClassName="form-item__field"
												/>
											</div>

										</div>
									</div>
									<div
										className='form-item form-item--text form-item--disabled account_type'
										data-module='molecules/form-item/FormItem'
									>
										<CommonInput
											type='text'
											label={t('COMMON.ACCOUNT_TYPE')}
											className='form-item-value'
											// className='form-item__field'
											value={t(getAccountType(userProfile))}
											maxLength='100'
											readOnly
										/>
										{/* <label className='form-item__label'>{t('COMMON.ACCOUNT_TYPE')}</label>
										<input
											type='text'
											// readOnly
											className='form-item__field m-0'
											value={t(getAccountType(userProfile))}
											maxLength='100'
										/> */}
									</div>
								</div>
								<div className='form-row airport-status-row'>
									<div
										className={`form-item form-item--text form-group common-autocomplete airport-code ${error && error['defaultAirportCode'] ? 'red-border' : ''}`}
										onFocus={clearDefaultAirportError}
										onBlur={() => {
											// Fire only when leaving the whole wrapper
											const code = (defaultAirportInput || selectedOrigin?.code || '').trim(); // FIX: replaced selectedAirportCode
											if (!code) {
												setDefaultAirportError();
											}
										}}
									>
										<div className='p-float-label input-wrapper'>
											<AirportAutocomplete
												inputId='defaultAirportCode'
												autoCompleteType={AUTOCOMPLETE_TYPE.ORIGIN}
												selectedOrigin={selectedOrigin}
												selectedDestination={selectedDestination}
												setSelectedOrigin={onSelectOrigin}
												handleSetError={handleDefaultAirportSetError}
												clearError={clearDefaultAirportError}
												draftCallback={() => { }}
												setNotificationMessage={() => { }}
												setNotificationType={() => { }}
											/>
											<label htmlFor='defaultAirportCode'>
												{t('COMMON.AIRPORT_CODE')}
											</label>
										</div>
										<span className='form-item__error'>
											{error && error['defaultAirportCode']
												? t(error['defaultAirportCode'], { ns: 'errors' })
												: ''}
										</span>
									</div>
									<div className='form-item form-item--text form-item--disabled'>
										
										<label className='form-item__label mb-0'>
											{t('COMMON.STATUS')}
										</label>
										<input
											type='text'
											className='form-item__field'
											value={USER_ACCOUNT_STATUS.find(opt => opt.value === userStatus)?.label || ''}
										/>
									</div>
								</div>
							</div>
						</CustomPopup>
					)}
					{!isUserInfoModalOpen && (
						<div className='user-info'>
							<div className='user-info-section'>
								<div className='user-info-header'>
									<div className='left-block'>
										<h3 className=' page-sub-heading mb-0'>
											{t('COMMON.USER_INFO')}
										</h3>
									</div>
									{/* <div className='right-block'>
                                        <span className='link edit-link-profile' onClick={openUserInfoModal}>
                                            {t('COMMON.EDIT')}
                                        </span>
                                    </div> */}
									<div className='right-block'>
										<BrandedLinkButton
											label={t('COMMON.EDIT')}
											onClick={openUserInfoModal}
											className="edit-link-profile"
										/>
									</div>
								</div>
								<div className='form-user-details'>
									<div className='form-row firstName '>
										<div
											className='form-item form-item--text '
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>
												{t('COMMON.USER_ID')}
											</label>
											<input
												type='text'
												readOnly
												className='form-item__field'
												value={userProfile.userId}
												maxLength='25'
											/>
										</div>
										<div
											className='form-item form-item--text  first-name m-0'
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>{t('COMMON.FIRST_NAME')}</label>
											<input
												type='text'
												id='firstName'
												{...bindFirstName}
												readOnly
												className='form-item__field first_name'
												maxLength='20'
											/>
										</div>
										<div
											className='form-item form-item--text  last-name'
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>{t('COMMON.LAST_NAME')}</label>
											<input
												type='text'
												id='lastName'
												{...bindLastName}
												readOnly
												className='form-item__field last_name p-0'
												maxLength='20'
											/>
										</div>

										{/* {!isEditable && (
                                            <div
                                                className='col-12 col-lg-3 form-item form-item--text form-item--disabled'
                                                data-module='molecules/form-item/FormItem'
                                            >
                                                <label className='form-item__label'>
                                                    {t('COMMON.NAME')}
                                                </label>
                                                <input
                                                    type='text'
                                                    readOnly
                                                    className='form-item__field'
                                                    value={`${userProfile.firstName ? userProfile.firstName : ''} ${userProfile.lastName ? userProfile.lastName : ''}`}
                                                    maxLength='20'
                                                />
                                            </div>
                                        )} */}
										{/* <div
											className='form-item form-item--text '
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>
												{t('COMMON.EMAIL')}
											</label>
											<input
												type='text'
												readOnly
												className='form-item__field'
												value={userProfile.email}
												maxLength='100'
											/>
										</div> */}
										{/* <div
											className='form-item form-item--text account_type'
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>{t('COMMON.ACCOUNT_TYPE')}</label>
											<input
												type='text'
												readOnly
												className='form-item__field'
												value={t(getAccountType(userProfile))}
												maxLength='100'
											/>
										</div> */}
										{/* <div
											className='form-item form-item--text  first-name m-0'
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>{t('COMMON.FIRST_NAME')}</label>
											<input
												type='text'
												id='firstName'
												{...bindFirstName}
												readOnly
												className='form-item__field first_name'
												maxLength='20'
											/>
										</div> */}
									</div>
									<div className='form-row lastName'>
										<div
											className='form-item form-item--text '
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>
												{t('COMMON.EMAIL')}
											</label>
											<input
												type='text'
												readOnly
												className='form-item__field'
												value={userProfile.email}
												maxLength='100'
											/>
										</div>
										

										<div
											className='form-item form-item--text mb-0'
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>
												{t('COMMON.MOB')}
											</label>

											<input
												id='mobNumber'
												value={
													mobileNumber && mobileNumber.trim()
														? `${mobContryCode || ''} ${mobileNumber.trim()}`
														: '-'
												}

												type='text'
												name='mobNumber'
												className='form-item__field p-0'
												readOnly
											/>
										</div>
										<div
											className='form-item form-item--text account_type'
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>{t('COMMON.ACCOUNT_TYPE')}</label>
											<input
												type='text'
												readOnly
												className='form-item__field'
												value={t(getAccountType(userProfile))}
												maxLength='100'
											/>
										</div>
									</div>

									<div className='form-row lastName'>
										<div
											className='form-item form-item--text'
											data-module='molecules/form-item/FormItem'
										>
											<label className='form-item__label'>
												{t('COMMON.AIRPORT_CODE')}
											</label>
											{/* <input
                                                type='text'
                                                readOnly
                                                className='form-item__field'
                                                value={
                                                    defaultAirportInput
                                                        ? defaultAirportInput
                                                        : (userProfile.defaultAirportCode || '-')
                                                }
                                                maxLength='3'
                                            /> */}
											<input
												type='text'
												readOnly
												className='form-item__field'
												value={defaultAirportDisplay}
												maxLength='30'
											/>
										</div>
										<div className='form-item form-item--text mb-0'>
											<label className='form-item__label'>
												{t('COMMON.STATUS')}
											</label>
											<input
												type='text'
												readOnly
												className='form-item__field'
												value={USER_ACCOUNT_STATUS.find(opt => opt.value === userStatus)?.label || ''}
											/>
										</div>
										<div className='form-item form-item--text mb-0'></div>
									</div>
									
								</div>
							</div>

							<div className='user-privileges pl-0'>
								<div className='title-privilege'>
									<label className='label-privilege mb-0'>{t('UM.PRIVILEGES')}</label>
								</div>
								{userProfileResponse &&
									userProfileResponse.userDetails &&
									userProfileResponse.userDetails.roles &&
									userProfileResponse.userDetails.roles.length ? (
									<div className='privilege-list'>
										{isEditable &&
											privileges.bookingPrivilege &&
											privileges.capturePrivilege &&
											privileges.dashBoardPrivilege &&
											privileges.allotmentPrivilege &&
											privileges.informaticsPrivilege && (
												<div className='privilege-item'>
													<img
														src={checkCircle}
														className='privilege-icon'
													/>
													<span className='privilege-label'>{t('COMMON.BKG')}</span>
												</div>
												
											)}

										{privileges.bookingPrivilege && (
											<div className='privilege-item'>
												<img
													src={checkCircle}
													className='privilege-icon'
												/>
												<span className='privilege-label'>{t('COMMON.BKG')}</span>
											</div>

										)}

										{privileges.capturePrivilege && (
											<div className='privilege-item'>
												<img
													src={checkCircle}
													className='privilege-icon'
												/>
												<span className='privilege-label'>{t('COMMON.DATA_CAPTURE')}</span>
											</div>

										)}

										{privileges.dashBoardPrivilege && (
											<div className='privilege-item'>
												<img
													src={checkCircle}
													className='privilege-icon'
												/>
												<span className='privilege-label'>{t('UM.DASHBOARD_DEFAULT_PRVLG')}</span>
											</div>

										)}

										{privileges.informaticsPrivilege && (
											<div className='privilege-item'>
												<img
													src={checkCircle}
													className='privilege-icon'
												/>
												<span className='privilege-label'>{t('UM.IFOGRPCS_PRVLG')}</span>
											</div>

										)}

										{privileges.allotmentPrivilege && (
											<div className='privilege-item'>
												<img
													src={checkCircle}
													className='privilege-icon'
												/>
												<span className='privilege-label'>{t('UM.ALLOTMNT_PRVLG')}</span>
											</div>

										)}
									</div>
								) : (
									<div className='form-row mt-3'>-</div>
								)}
							</div>
						</div>

					)}


					<div className='preferences-info'>
						<div className='form-row preferences-row '>
							<h3 className=' title'>
								{t('USER_MANAGEMENT.PREFERENCES_TITLE')}
							</h3>
							<h2 className=' sub-title'>
							{t('USER_MANAGEMENT.PREFERENCES_SUB_TITLE')}
							</h2>
						</div>

						<div className='settings-option'>
							<div className='form-row user-info-header'>
								<div className='left-block'>
									<img
										src={Globe}
										alt="Globe"
										className="globe"
									/>
									<h3 className='col-10 page-sub-heading'>
										{t('COMMON.PREF')}
									</h3>
								</div>
								{/* <div className='right-block'>
                                    <span className='link edit-link-profile' onClick={openPreferencesModal}>
                                        {t('COMMON.EDIT')}
                                    </span>
                                </div> */}
								<div className='right-block'>
									<BrandedLinkButton
										label={t('COMMON.EDIT')}
										onClick={openPreferencesModal}
										className="edit-link-profile"
									/>
								</div>
							</div>
							{isPreferencesModalOpen && (

								<CustomPopup
									isVisible={isPreferencesModalOpen}
									onClose={closePreferencesModal}
									headerComponent={{
										mainHeader: t('COMMON.PREF'),
										subHeader: t('USER_MANAGEMENT.PREFERENCES_SUBHEADER')
									}}
									showMobileBackButton="true"
									footerPriBtnLabel={t('MNGTMPLT.SAVE_CHANGES')}
									footerPriBtnDisabled={!isEditable && disableSaveButton} // same disable condition
									footerPriBtnClick={(evt) => {
										evt.preventDefault(); // match form behavior
										handleSubmit(evt);
										if (isEditable || !disableSaveButton) {
											closePreferencesModal();
										}
									}}
									footerSecBtnClick={() => {
										if (isCancelEnabled()) {
											handleCancel();
										}
										closePreferencesModal();
									}}
								>




									<div className='preferences-info-content'>
										<h3 className='title'>{t('COMMON.LANG')}</h3>
										<div className='form-row'>
											<div className='lang-selector form-item pl-2 mb-0'>
												<CommonDropDown
													className='cust-dropdown'
													value={preferences.language}
													options={LANGUAGES}
													label={t('COMMON.LANG')}
													onChange={onChangeLanguage}
													disabled={!MULTILANGUAGE_SUPPORT_ENABLED}
												></CommonDropDown>
											</div>
										</div>
										<h3 className='title'>{t('COMMON.MEASURE')}</h3>
										<div className='form-row measurements m-0'>
											<div className='form-item'>
												<CommonDropDown
													className='cust-dropdown'
													value={preferences.weightUnit}
													options={WEIGHT_UNIT_SELECT_ITEMS}
													label={t('COMMON.WT')}
													onChange={onChangeWeightUnit}

												></CommonDropDown>
											</div>
											<div className='form-item'>
												<CommonDropDown
													className='cust-dropdown'
													value={preferences.dimensionUnit}
													options={DIMENSION_UNIT_SELECT_ITEMS}
													label={t('COMMON.DIM')}
													onChange={onChangeDimensionUnit}
												></CommonDropDown>
											</div>
										</div>
									</div>
								</CustomPopup>
							)}


							<div className='form-row user-info-header mb-0'>
								<div className='left-block'>
									<img
										src={Bell}
										alt="Notification"
										className="notification"
									/>
									<h3 className='col-10  page-sub-heading notification'>
										{t('COMMON.NOTIFICATION')}
									</h3>
								</div>
								{/* <div className='right-block'>
                                    <span className='link edit-link-profile' onClick={openNotificationsModal}>
                                        {t('COMMON.EDIT')}
                                    </span>
                                </div> */}
								<div className='right-block'>
									<BrandedLinkButton
										label={t('COMMON.EDIT')}
										onClick={openNotificationsModal}
										className="edit-link-profile"
									/>
								</div>
							</div>

							{isNotificationsModalOpen && (
								<CustomPopup
									isVisible={isNotificationsModalOpen}
									onClose={closeNotificationsModal}
									headerComponent={{
										mainHeader: t('COMMON.NOTIFICATION'),
										subHeader: t('USER_MANAGEMENT.NOTIFICATION_SUBHEADER')
									}}
									showMobileBackButton="true"
									footerPriBtnLabel={t('MNGTMPLT.SAVE_CHANGES')}
									footerPriBtnDisabled={!isEditable && disableSaveButton} // same disable logic
									footerPriBtnClick={(evt) => {
										evt.preventDefault(); // match form behavior
										handleSubmit(evt);
										if (isEditable || !disableSaveButton) {
											closeNotificationsModal();
										}
									}}
									footerSecBtnClick={() => {
										if (isCancelEnabled()) {
											handleCancel();
										}
										closeNotificationsModal();
									}}
								>



									<div className='notification-info'>
										<div className='form-row'>

											<div className=' notify_list'>
												<div className='notification'>
													<div
														className='form-item l-checkbox'
														data-module='molecules/form-item/FormItem'
													>
														<input
															id='milestone1'
															checked={milestones.milestone1}
															value='All'
															type='checkbox'
															name='milestone1'
															onChange={handleChangeMilestone}
														/>
														<label
															htmlFor='milestone1'
															className='form-item__label'
														>
															{t('COMMON.ALL')}
														</label>
													</div>
												</div>
												<div className='notification'>
													<div
														className='form-item l-checkbox'
														data-module='molecules/form-item/FormItem'
													>
														<input
															id='milestone3'
															checked={milestones.milestone3}
															value='Departed'
															type='checkbox'
															name='milestone3'
															onChange={handleChangeMilestone}
														/>
														<label
															htmlFor='milestone3'
															className='form-item__label'
														>
															{t('COMMON.DEPARTED')}
														</label>
													</div>
												</div>
												<div className='notification'>
													<div
														className='form-item l-checkbox'
														data-module='molecules/form-item/FormItem'
													>
														<input
															id='milestone5'
															checked={milestones.milestone5}
															value='Notified'
															type='checkbox'
															name='milestone5'
															onChange={handleChangeMilestone}
														/>
														<label
															htmlFor='milestone5'
															className='form-item__label'
														>
															{t('COMMON.NOTIFIED')}
														</label>
													</div>
												</div>
												<div className='notification'>
													<div
														className='form-item l-checkbox'
														data-module='molecules/form-item/FormItem'
													>
														<input
															id='milestone2'
															checked={milestones.milestone2}
															value='Accepted'
															type='checkbox'
															name='milestone2'
															onChange={handleChangeMilestone}
														/>
														<label
															htmlFor='milestone2'
															className='form-item__label'
														>
															{t('COMMON.ACCEPTED')}
														</label>
													</div>
												</div>

												<div className='notification'>
													<div
														className='form-item l-checkbox'
														data-module='molecules/form-item/FormItem'
													>
														<input
															id='milestone4'
															checked={milestones.milestone4}
															value='Arrived'
															type='checkbox'
															name='milestone4'
															onChange={handleChangeMilestone}
														/>
														<label
															htmlFor='milestone4'
															className='form-item__label'
														>
															{t('COMMON.ARRIVED')}
														</label>
													</div>
												</div>

												<div className='notification'>
													<div
														className='form-item l-checkbox'
														data-module='molecules/form-item/FormItem'
													>
														<input
															id='milestone6'
															checked={milestones.milestone6}
															value='Delivered'
															type='checkbox'
															name='milestone6'
															onChange={handleChangeMilestone}
														/>
														<label
															htmlFor='milestone6'
															className='form-item__label'
														>
															{t('COMMON.DELIVERED')}
														</label>
													</div>
												</div>
											</div>

										</div>
									</div>
								</CustomPopup>
							)}


						</div>
					</div>
					<div className='booking-container'>
						<div className="booking-content">
							<div className="booking-headers">
								<h2>{t('USER_MANAGEMENT.BOOKING_TITLE')}</h2>
								<p>{t('USER_MANAGEMENT.BOOKING_TITLE')}</p>
							</div>
							<div className='book-button'>
								<BrandedLinkButton
									label={t('BOOKING_SUMMARY.BOOK')}
									onClick={handleBooking}

								/>
							</div>
						</div>
						<div className="booking-image">
							<img
								src={EtihadCargo}
								alt="Etihad Cargo"
								className="etihad-cargo"
							/>
						</div>
					</div>
					{/* <div className='form-row custom-mt-5'>
                        <div className='cta_wrap flex-column-reverse flex-lg-column custom-ml-1 custom-mt-3'>
                            <button
                                className='primary-button'
                                onClick={handleSubmit}
                                disabled={!isEditable && disableSaveButton}
                            >
                                {t('COMMON.SAVE')}
                            </button>
                            {isCancelEnabled() && (
                                <button
                                    className='secondary-button custom-ml-4'
                                    onClick={handleCancel}
                                >
                                    {t('COMMON.CANCEL')}
                                </button>
                            )}
                        </div>
                    </div> */}
				</div>
			)}
		</div>
	)
}
const mapStateToProps = ({ userProfile }) => ({
	userProfileResponse: userProfile.response,
	userProfileError: userProfile.error,
})
const mapDispatchToProps = (dispatch) => ({
	getBookingDetails: (userCode) => {
		dispatch(loadUserProfile(userCode))
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile)



